import React from "react";
import styled from "styled-components";
import logoImg from "../assets/images/logo-image.png"; // Import the same logo

const FooterContainer = styled.footer`
  background: #2c3e50;
  color: white;
  padding: 2rem 1rem 1rem;

  @media (max-width: 768px) {
    padding: 2rem 1rem 1rem;
  }

  @media (max-width: 480px) {
    padding: 1.5rem 1rem;
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  column-gap: 8rem;
  row-gap: 1.5rem;
  margin-bottom: 1rem;

  @media (max-width: 1024px) {
    column-gap: 2rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    column-gap: 0;
    row-gap: 1.5rem;
    text-align: center;
    justify-items: center;
  }
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const LogoImage = styled.img`
  width: 120px; /* Adjust as needed */
  height: auto;
  object-fit: contain;
  border-radius: 8px;

  @media (min-width: 768px) {
    width: 120px;
  }
`;

const Description = styled.p`
  font-size: 0.9rem;
  color: #bdc3c7;
  line-height: 1.4;
  margin: 0.2rem 0 0.5rem;
  max-width: 500px;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const QuickLinksTitle = styled.h3`
  font-size: 1rem;
  margin-bottom: 0.3rem;
  color: #ecf0f1;
`;

const QuickLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const QuickLink = styled.a`
  color: #bdc3c7;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: #ff914d;
  }
`;

const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const ContactTitle = styled.h3`
  font-size: 1rem;
  margin-bottom: 0.3rem;
  color: #ecf0f1;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #bdc3c7;
  font-size: 0.9rem;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

// const SocialLinks = styled.div`
//   display: flex;
//   gap: 0.8rem;
//   margin-top: 0.5rem;

//   @media (max-width: 768px) {
//     justify-content: center;
//   }
// `;

// const SocialLink = styled.a`
//   width: 32px;
//   height: 32px;
//   background: linear-gradient(45deg, #3dccc7, #2a5a7a);
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: white;
//   text-decoration: none;
//   transition: transform 0.3s ease;

//   &:hover {
//     transform: translateY(-2px);
//   }
// `;

const BottomBar = styled.div`
  border-top: 1px solid #34495e;
  padding-top: 0.8rem;
  text-align: center;
  color: #95a5a6;
  font-size: 0.8rem;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <LeftSection>
          <LogoSection>
            <LogoImage src={logoImg} alt="AI Building Skills Logo" />
          </LogoSection>

          <Description>
            AI Building Skills is your go-to hub for mastering AI Tools in
            construction.
          </Description>
          <Description>
            From cost estimation to project coordination, learn how to boost
            efficiency with AI.
          </Description>
        </LeftSection>

        <RightSection>
          <div>
            <QuickLinksTitle>Quick Links</QuickLinksTitle>
            <QuickLinks>
              <QuickLink href="/terms">Terms of Service</QuickLink>
              <QuickLink href="/privacy">Privacy Policy</QuickLink>
            </QuickLinks>
          </div>
          <ContactInfo>
            <ContactTitle>Contact Information</ContactTitle>
            <ContactItem>
              <span>📧</span>
              <span>info@aibuildskills.com</span>
            </ContactItem>

            {/* <SocialLinks>
              <SocialLink href="#" aria-label="LinkedIn">💼</SocialLink>
              <SocialLink href="#" aria-label="Twitter">🐦</SocialLink>
              <SocialLink href="#" aria-label="Facebook">📘</SocialLink>
              <SocialLink href="#" aria-label="YouTube">📺</SocialLink>
            </SocialLinks> */}
          </ContactInfo>
        </RightSection>
      </FooterContent>

      <BottomBar>
        <p>
          &copy; 2025 AI Build Skills. All rights reserved. | Empowering
          construction professionals with AI technology.
        </p>
      </BottomBar>
    </FooterContainer>
  );
};

export default Footer;
